import ScrimWrapper, {
  ARROW_TYPES,
  SCRIM_DEFAULT_ZINDEX,
} from './ScrimWrapper';

export default ScrimWrapper;
export { ARROW_TYPES, SCRIM_DEFAULT_ZINDEX };
